import { GovernanceActionType } from '@src/models/enum';
import type { IGovernanceAction } from '@src/models/types';
import ConstitutionProposalDetails from '@src/components/molecules/governance-action-detail/govActionExtraDetails/constitutionDetails';
import NewCommitteeParameters from '@src/components/molecules/governance-action-detail/govActionExtraDetails/newCommitteeParameters';
import ProtocolParameterChange from '@src/components/molecules/governance-action-detail/govActionExtraDetails/protocolParameterChange';

export default function GovernanceExtraActionDetailsPage({
  governanceAction,
}: {
  governanceAction: IGovernanceAction;
}) {
  const { proposal } = governanceAction;
  if (proposal.type === GovernanceActionType.UpdateToTheConstitution)
    return <ConstitutionProposalDetails proposal={proposal} />;
  if (proposal.type === GovernanceActionType.NewCommittee)
    return <NewCommitteeParameters proposal={proposal} />;
  if (proposal.type === GovernanceActionType.ProtocolParameterChange)
    return <ProtocolParameterChange governanceAction={governanceAction} />;
  return <div></div>;
}
